export class TranslationDropdown {
    constructor() {
        this.dropdown = document.querySelectorAll('.languages-dropdown');
    }

    init() {
        this.dropdown.forEach((dropdown) => {
            dropdown.addEventListener('change', this.onDropdownChange.bind(this));
        });
    }

    getEnglishUrl() {
        return `https://${this.getCurrentDomain()}${this.getCurrentPath()}`;
    }

    getNonEnglishUrl(languageCode) {
        return `https://${this.getGoogleTranslateDomain()}.translate.goog${this.getCurrentPath()}?_x_tr_sl=auto&_x_tr_tl=${languageCode}&_x_tr_hl=en&_x_tr_pto=wapp`;
    }

    // eslint-disable-next-line class-methods-use-this
    getCurrentPath() {
        return window.location.pathname;
    }

    // eslint-disable-next-line class-methods-use-this
    getCurrentDomain() {
        return window.c5Domain;
    }

    // eslint-disable-next-line class-methods-use-this
    getGoogleTranslateDomain() {
        return this.getCurrentDomain().replace(/-/g, '--').replace(/\./g, '-');
    }

    getGoogleTranslateUrl(lang) {
        if (lang === 'en') return this.getEnglishUrl();
        return this.getNonEnglishUrl(lang);
    }

    onDropdownChange(e) {
        const lang = e.target.value;
        window.location.href = this.getGoogleTranslateUrl(lang);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const translationDropdown = new TranslationDropdown();
    translationDropdown.init();
});